/**
 * 하객이 기기에서 모션 줄이기를 켰는지 본다.
 *
 * matchMedia가 없는 환경(jsdom 등)에서는 false를 돌려준다 — 판단할 수 없을 때는
 * 원래 동작을 유지한다. 매번 물어보는 것은 값이 세션 중에도 바뀔 수 있기 때문이다.
 */
export function prefersReducedMotion(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches
}
